var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MyNavBar',{attrs:{"back":"","title":"操作指引"},on:{"onBackClick":_vm.onBackClick}}),_c('div',{staticStyle:{"text-align":"center","margin-top":"32px"}},[_vm._v("正在更新维护中....")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }